import React from "react";

const TextCellRenderer = (props) => {
    const { value } = props;

    return (value !== undefined ? <p>{`${value.replace(/,/g, ',<br/>')}`}</p> : '');
}

export default TextCellRenderer;
